var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRotate = function SvgRotate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#C7C7CC",
    d: "M6.623 5.708c-.659.485-1.34.29-1.34-.56V3.66h-.022c-2.383 0-3.888 1.627-3.888 3.932 0 1.433.45 1.972.472 2.36.011.301-.099.484-.351.603-.34.161-.736.01-.923-.302C.231 9.683 0 8.735 0 7.582c0-3.08 2.087-5.16 5.25-5.16h.033V.84c0-.873.67-1.067 1.34-.571l2.999 2.154c.505.366.505.787 0 1.142zM19.177 24H8.293c-1.879 0-2.823-.883-2.823-2.769V10.577c0-1.885.944-2.768 2.823-2.768h10.884c1.878 0 2.823.883 2.823 2.768v10.654C22 23.117 21.055 24 19.177 24"
  })));
};
export default SvgRotate;